import {
  missingLocationMessage,
  missingPatientAddressMessage,
  missingPayerMessage,
  payerNotAllowedMessage,
  zollMsg,
  missingChiefComplaintMessage,
  chiefComplaintNotAllowedMessage,
  missingPatientName,
  changesNotSaved,
  missingPatientWeightHeight,
  eaRunRequired,
  eaRunRequiredForOriginalTrip,
  eaRunStatusChecking,
  eaRunStatusUnavailable,
} from '../messages';
import {
  prebillerVerifiedLocationMissing,
  patientAddressMissing,
  prebillerVerifiedPayerMissing,
  disabledByPcrStatus,
  chiefComplaintMissing,
  chiefComplaintNotAllowed,
  payerNotAllowed,
  patientInvalid,
  changesNotSavedYet,
  patientWeightHeightMissing,
  prebillerVerifiedEaRunMissing,
  prebillerVerifiedEaRunStatusUnavailable,
} from '../flags/prebilling.flag';

const getBillerVerifiedTooltip = state => {
  let messages = [];

  if (prebillerVerifiedEaRunMissing(state)) {
    const { request } = state.requests;
    const runStatus = state.eligibility.runStatus;
    const hasCurrentStatus = runStatus.requestId === request?.id;
    if (!request?.id) {
      messages.push(changesNotSaved);
    } else if (!hasCurrentStatus || !['success', 'failure'].includes(runStatus.status)) {
      messages.push(eaRunStatusChecking);
    } else if (request.originalRequestId) {
      messages.push(eaRunRequiredForOriginalTrip);
    } else {
      messages.push(eaRunRequired);
    }
  }

  if (prebillerVerifiedLocationMissing(state)) messages.push(missingLocationMessage);
  if (patientAddressMissing(state)) messages.push(missingPatientAddressMessage);
  if (patientWeightHeightMissing(state)) messages.push(missingPatientWeightHeight);
  if (prebillerVerifiedPayerMissing(state)) messages.push(missingPayerMessage);
  if (payerNotAllowed(state)) messages.push(payerNotAllowedMessage);
  if (disabledByPcrStatus(state)) messages = [zollMsg];
  if (chiefComplaintMissing(state)) messages.push(missingChiefComplaintMessage);
  if (chiefComplaintNotAllowed(state)) messages.push(chiefComplaintNotAllowedMessage);
  if (patientInvalid(state)) messages.push(missingPatientName);
  if (changesNotSavedYet(state)) messages.push(changesNotSaved);
  if (prebillerVerifiedEaRunStatusUnavailable(state)) messages.push(eaRunStatusUnavailable);

  return [...new Set(messages)].join('\n');
};
export default getBillerVerifiedTooltip;
